import { Link, NavLink } from "react-router-dom";
import { useState } from "react";
import { List, X, MagnifyingGlass } from "@phosphor-icons/react";
import StickyFlightBar from "./StickyFlightBar";

const NAV = [
  { to: "/booking", label: "Book" },
  { to: "/deals", label: "Deals" },
  { to: "/travel-hacks", label: "Travel Hacks" },
  { to: "/points-miles", label: "Points & Miles" },
  { to: "/airlines", label: "Airlines" },
  { to: "/hotels", label: "Hotels" },
  { to: "/destinations", label: "Destinations" },
  { to: "/reviews", label: "Reviews" },
  { to: "/credit-cards", label: "Credit Cards" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-40 bg-[#F9F9F6]/92 backdrop-blur-md border-b border-[#D6CFC4]" data-testid="site-header">
      <div className="container-page flex items-center justify-between h-16 md:h-20">
        <Link to="/" className="flex items-baseline gap-2" data-testid="logo-link">
          <span className="font-serif text-2xl md:text-3xl font-semibold tracking-tight text-[#1B3B36]">JetsetLess</span>
          <span className="overline text-[#B4533C] hidden md:inline">Premium Travel Media</span>
        </Link>
        <nav className="hidden lg:flex items-center gap-7 text-sm font-medium text-[#1C1A17]" data-testid="primary-nav">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              data-testid={`nav-${n.to.slice(1)}`}
              className={({ isActive }) =>
                `hover:text-[#B4533C] transition-colors ${isActive ? "text-[#B4533C]" : ""}`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <Link to="/admin" className="hidden md:block overline text-[#4A4742] hover:text-[#1B3B36]" data-testid="admin-entry-link">
            Admin
          </Link>
          <button onClick={() => setOpen(!open)} className="lg:hidden" aria-label="Toggle menu" data-testid="mobile-menu-toggle">
            {open ? <X size={22} weight="regular" /> : <List size={22} weight="regular" />}
          </button>
        </div>
      </div>
      {open && (
        <div className="lg:hidden border-t border-[#D6CFC4] bg-white">
          <div className="container-page py-4 grid grid-cols-2 gap-3">
            {NAV.map((n) => (
              <Link key={n.to} to={n.to} className="py-2 text-sm" onClick={() => setOpen(false)} data-testid={`mobile-nav-${n.to.slice(1)}`}>
                {n.label}
              </Link>
            ))}
          </div>
        </div>
      )}
      <StickyFlightBar />
    </header>
  );
}
